import React from "react";
import { Link } from "react-router-dom";

import { Tooltip } from "components";
import { RiseSystemUserRoleName } from "globalConstants";
import { getFullName, useGetUserPageUrlForHistory } from "helpers";

import styles from "../historyTable.module.scss";

const userColumn = ({ currentUser }) => ({
	Header: "User",
	accessor: "created_by",
	disableSortBy: true,
	classNameHeader: styles.userColHeader,
	classNameCell: styles.userCol,
	Cell: ({
		row: {
			original: { created_by },
		},
	}) => {
		const linkToUser = useGetUserPageUrlForHistory(
			currentUser,
			created_by?.role?.name,
			created_by?.id,
		);

		const isSystemUser = created_by?.role?.name === RiseSystemUserRoleName;

		return (
			<Tooltip
				title={`${created_by?.role?.name} - ${created_by?.agent_office?.name}`}
			>
				{linkToUser && !isSystemUser ? (
					<Link target="_blank" to={linkToUser}>
						{getFullName(created_by)}
					</Link>
				) : (
					getFullName(created_by)
				)}
			</Tooltip>
		);
	},
});

export default userColumn;
